import script from "./editableTextarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./editableTextarea.vue?vue&type=script&setup=true&lang=ts"

import "./editableTextarea.vue?vue&type=style&index=0&id=3505fcab&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3505fcab"]])

export default __exports__